__webpack_require__.p = "/apps/legal-entity-account-opening/production/";